import React from 'react';
import { Linking, View } from 'react-native';
import { Text } from '@ui-kitten/components';

import constants from '../../../Config/constants';
import themeStyle from '../../../Theme/styles';

import Button from '../../Button';
import Image from '../../Image';
import List from '../../List';

import styles from '../styles';

import { RenderProps } from './types';

const mapOptions = [
  {
    image:
      'https://pbs.twimg.com/profile_images/1611472516920520705/gWLeDDCJ_400x400.jpg',
    title: 'Waze',
    subTitle: 'Waze, Inc',
    urlPrefix: 'https://www.waze.com/ul?ll=',
  },
  ...(constants.isIOS
    ? [
        {
          image:
            'https://www.apple.com/v/maps/d/images/overview/intro_icon__dfyvjc1ohbcm_large.png',
          title: 'Maps',
          urlPrefix: 'maps:0,0?q=',
        },
      ]
    : [
        {
          image:
            'https://images.seeklogo.com/logo-png/26/1/new-google-maps-icon-logo-png_seeklogo-268336.png',
          title: 'Google Maps',
          subTitle: 'Google, Inc',
          urlPrefix: constants.isAndroid
            ? 'geo:0,0?q='
            : 'https://maps.google.com/?q=',
        },
      ]),
];

const MapAppOptionsRender = (data: RenderProps) => {
  const _onSelect = (url: string) => {
    Linking.openURL(url);
  };

  return (
    <View style={styles.contentContainerNoHPadding}>
      <Text
        style={[
          themeStyle.pageHorizontalSpacing,
          themeStyle.spacingBottomSmall,
          themeStyle.bold,
        ]}
      >
        Open places and directions with:
      </Text>
      <List
        data={mapOptions}
        renderItem={({ item }) => (
          <View
            style={[
              themeStyle.pageVerticalSpacingMedium,
              themeStyle.pageHorizontalSpacing,
            ]}
          >
            <View style={themeStyle.flexDirectionRowCenter}>
              <View style={{ borderRadius: 4, overflow: 'hidden' }}>
                <Image
                  source={{ uri: item.image }}
                  style={{ width: 50, height: 50 }}
                  resizeMode="cover"
                />
              </View>
              <View
                style={[
                  themeStyle.flex1,
                  themeStyle.pageHorizontalSpacingSmall,
                ]}
              >
                <Text style={themeStyle.bold}>{item.title}</Text>
                <Text category="c1">{item.subTitle}</Text>
              </View>
              <View>
                <Button
                  size="small"
                  status="info"
                  style={{ borderRadius: 5 }}
                  onPress={() =>
                    _onSelect(`${item.urlPrefix}${data.lat},${data.lng}`)
                  }
                >
                  OPEN
                </Button>
              </View>
            </View>
          </View>
        )}
        withSeparator
        plain
      />
    </View>
  );
};

export default MapAppOptionsRender;
